'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dEnum$002dSample$0024package$0024$002dColor$00241 from "./samples.-Enum-Sample$package$-Color$1.js";
import * as $j_scala$002eruntime$002e$002dEnum$002dValue from "./scala.runtime.-Enum-Value.js";
var $p;
/** @constructor */
function $c_Lsamples_EnumSample$package$Color$3$$anon$3(Color$lzy1$13, outer) {
  this.sA = null;
  if ((outer === null)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_NullPointerException__(new $j_java$002elang$002e$002dObject.$c_jl_NullPointerException());
  }
  $j_samples$002e$002dEnum$002dSample$0024package$0024$002dColor$00241.$ct_Lsamples_EnumSample$package$Color$1__T__(this, "???");
}
export { $c_Lsamples_EnumSample$package$Color$3$$anon$3 as $c_Lsamples_EnumSample$package$Color$3$$anon$3 };
$p = $c_Lsamples_EnumSample$package$Color$3$$anon$3.prototype = new $j_samples$002e$002dEnum$002dSample$0024package$0024$002dColor$00241.$h_Lsamples_EnumSample$package$Color$1();
$p.constructor = $c_Lsamples_EnumSample$package$Color$3$$anon$3;
/** @constructor */
function $h_Lsamples_EnumSample$package$Color$3$$anon$3() {
}
export { $h_Lsamples_EnumSample$package$Color$3$$anon$3 as $h_Lsamples_EnumSample$package$Color$3$$anon$3 };
$h_Lsamples_EnumSample$package$Color$3$$anon$3.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return "Isabelle";
});
$p.b = (function() {
  return "Isabelle";
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$f_T__hashCode__I("Isabelle");
});
$p.y = (function(p) {
  return this;
});
var $d_Lsamples_EnumSample$package$Color$3$$anon$3 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_EnumSample$package$Color$3$$anon$3, "samples.EnumSample$package$Color$3$$anon$3", ({
  pb: 1,
  bx: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Lsamples_EnumSample$package$Color$3$$anon$3 as $d_Lsamples_EnumSample$package$Color$3$$anon$3 };
